var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('Navbar',{attrs:{"title":_vm.$t('page.financialRecord')}}),_c('FinancialRecord')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }